'use strict';
Object.defineProperty(exports, "__esModule", { value: true });
const $ = require("jquery");
const hamburger_1 = require("./class/common/hamburger");
const scroll_1 = require("./class/common/scroll");
const contact_1 = require("./class/contact/contact");
const accordion_1 = require("./class/common/accordion");
$(() => {
    new hamburger_1.default();
    new scroll_1.default();
    new contact_1.default();
    new accordion_1.default();
});
